import { z } from 'zod';

/**
 * GET /api/version — public (no-auth) build provenance for the running deployment
 * (feature/version-footer). `gitSha` is the short commit SHA the image was built
 * from and `buildTime` is the ISO-8601 UTC image-build timestamp; both are baked
 * into the Docker image at build time. Either is `null` when unset — the local dev
 * process has neither, and the web footer then renders a quiet "local dev".
 */
export const versionInfo = z.object({
  gitSha: z.string().nullable(),
  buildTime: z.string().nullable(),
});
export type VersionInfo = z.infer<typeof versionInfo>;
